<div class="row">
  <div class="col-12 mb-4">
    <p class="mbottom-12 [&_a]:underline [&_a]:text-p-40" yat-link *yatVar="deleteDate$ | async as deleteDate">
      <transloco
        id="a529407d-cc50-4d9e-968e-a72a7c76b7d3"
        key="accountUi.acceptNewTermsUi.updatedTerms"
        [params]="{
          termsLink: {
            url: TERMS_OF_SERVICE_URL,
            target: '_blank',
            class: 'link link-primary link-underline !text-base',
            trackingEvent: {
              category: MATOMO_EVENT_CATEGORY_LEGAL,
              action: 'Select_UpdateTermsAndPrivacy',
              name: 'TermsOfService'
            },
            id: 'ae001705-9aac-4016-a28c-ef9146cbdad9'
          },
          privacyPolicyLink: {
            url: PRIVACY_POLICY_URL,
            target: '_blank',
            class: 'link link-primary link-underline !text-base',
            trackingEvent: {
              category: MATOMO_EVENT_CATEGORY_LEGAL,
              action: 'Select_UpdateTermsAndPrivacy',
              name: 'PrivacyPolicy'
            },
            id: '716a31fd-fec2-459a-93c4-7f578970c985'
          },
          deleteDate: deleteDate ? (deleteDate | translocoDate: { dateStyle: 'long' }) : ''
        }"></transloco>
    </p>
  </div>
  <div class="col-12">
    <yat-buttons
      [primaryButtonName]="('acceptAndContinue' | commonWording | async) ?? ''"
      [secondaryButtonName]="('decline' | commonWording | async) ?? ''"
      [verticalAlignment]="true"
      (primaryButtonClickMethod)="accept()"
      (secondaryButtonClickMethod)="decline()">
    </yat-buttons>
  </div>
</div>
